import {match} from 'ts-pattern';

import {CustomNoticeRelation, RelatedCustomNoticesResourceId} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';

const getEntityResourceLabel = (resourceId: RelatedCustomNoticesResourceId) =>
  match(resourceId)
    .with(EntityResourceIds.customer, () => i18n.t('entity.customer.labels.customer'))
    .with(EntityResourceIds.vehicle, () => i18n.t('entity.vehicle.labels.vehicle'))
    .with(EntityResourceIds.businessCase, () => i18n.t('page.businessCase.labels.businessCase'))
    .with(EntityResourceIds.interest, () => i18n.t('entity.interest.labels.interest'))
    .with(EntityResourceIds.serviceCase, () => i18n.t('page.workshop.labels.serviceCase'))
    .with(EntityResourceIds.tireOrder, () => i18n.t('page.tiresInventory.labels.tireOrder'))
    .with(EntityResourceIds.rentalOrder, () => i18n.t('entity.rentalOrder.labels.rentalOrder'))
    .with(EntityResourceIds.workshopInterest, () => i18n.t('page.workshop.labels.workshopInterest'))
    .with(EntityResourceIds.directSale, () => i18n.t('page.warehouse.labels.directSale'))
    .exhaustive();

export function getCustomNoticeRelationLabel(
  relation: CustomNoticeRelation,
  hostResourceId: RelatedCustomNoticesResourceId
) {
  return match(relation)
    .with('own', () => getEntityResourceLabel(hostResourceId))
    .with('ownership', () => i18n.t('entity.customer.labels.ownership'))
    .with('customer', () => getEntityResourceLabel(EntityResourceIds.customer))
    .with('vehicle', () => getEntityResourceLabel(EntityResourceIds.vehicle))
    .with('interest', () => getEntityResourceLabel(EntityResourceIds.interest))
    .with('businessCase', () => getEntityResourceLabel(EntityResourceIds.businessCase))
    .with('serviceCase', () => getEntityResourceLabel(EntityResourceIds.serviceCase))
    .with('tireOrder', () => getEntityResourceLabel(EntityResourceIds.tireOrder))
    .with('rentalOrder', () => getEntityResourceLabel(EntityResourceIds.rentalOrder))
    .with('workshopInterest', () => getEntityResourceLabel(EntityResourceIds.workshopInterest))
    .with('directSale', () => getEntityResourceLabel(EntityResourceIds.directSale))
    .exhaustive();
}
